module.exports = __webpack_public_path__ + "static/media/c2.bb7a0813.mp3";